import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import AccessDeviceFields from './AccessDeviceFields'

export const AccessDeviceCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <AccessDeviceFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default AccessDeviceCreate
